import Broadcast from "../swipper/swiper";
import lazyload from "../lazyload/index";

let swipper = {
  inserted: (el, binding) => {
    new Broadcast(el, binding.value, {
      transitionTime: 800, // 动画过渡时间，默认为800ms
      intervalTime: 5000 // 图片切换时间，默认为5s
    });
  }
};

let lazy = {
  inserted: (el, binding) => {
    lazyload(el, binding.value);
  }
};

export { swipper, lazy };
